export default __webpack_public_path__ + "static/media/DoAmD_6XgAA3p2P.96e696da.jpg";